import { createDestinationRouteCondition } from '@/abilities/routeCondition';
import { useCompanyWorkspaceAccess } from '@/abilities/companyWorkspace/useCompanyWorkspaceAccess';

export const companyWorkspaceRoute = createDestinationRouteCondition(useCompanyWorkspaceAccess);
